
const cleanPercentage = (percentage) => {
  const tooLow = !Number.isFinite(+percentage) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : +percentage;
};

const ProgressLine = ({ percentage, colour, error, className }) => {
  const pct = cleanPercentage(percentage);

  return (
    <div className={`w-full h-2 bg-gray-200 rounded-full overflow-hidden ${className}`}>
      <div
        className='h-full rounded-full transition-all duration-300'
        style={{
          width: `${pct}%`,
          backgroundColor: error ? '#ef4444' : colour || '#3b82f6',
        }}
      />
    </div>
  );
};

export default ProgressLine;
